export const bitbankAccountCategory = 'bitbank'

export const networkEvmChainIds: Record<string, number | undefined> = {
  arbitrum: 42_161,
  avalanche: 43_114,
  bsc: 56,
  ethereum: 1,
  oasys: 248,
  op: 10,
  polygon: 137,
}

export const networkPolkadotChainIds: Record<string, number | undefined> = {
  polkadot: 0,
}

export const solanaNetwork = 'solana'
